<script lang="ts" setup>
withDefaults(defineProps<{
  label?: string | null
  value?: string | number | null
  variant?: 'primary' | 'error' | 'secondary'
  size?: 'sm' | 'md'
  title?: string
}>(), {
  label: null,
  value: null,
  variant: 'secondary',
  size: 'md',
  title: undefined,
})
</script>

<template>
  <div class="grouping-badge">
    <span
      v-if="label"
      class="grouping-badge__label"
    >{{ label }}</span>
    <slot>
      <div
        class="grouping-badge__value"
        :class="[`grouping-badge__value--${variant}`, `grouping-badge__value--${size}`]"
        :title="title"
      >
        {{ value ?? '-' }}
      </div>
    </slot>
  </div>
</template>

<style scoped lang="scss">
@import '@/design-system/tokens/colors';

.grouping-badge {
  display: flex;
  flex-direction: column;
  gap: 3px;

  &__label {
    font-weight: 700;
    font-size: 12px;
    line-height: 1.4;
    white-space: nowrap;
  }

  &__value {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.4;
    white-space: nowrap;

    &--primary {
      background-color: $grouping-badge-primary-bg;
    }

    &--error {
      background-color: $grouping-badge-error-bg;
    }

    &--secondary {
      background-color: $grouping-badge-secondary-bg;
    }

    &--sm {
      padding: 2px 5px;
      font-size: 1rem;
    }
  }
}
</style>
